/*
 * @Author: cc
 * @Date: 2019-12-26 11:46:35
 * @LastEditTime: 2022-01-20 15:00:47
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\kuaishou\pending\pending.js
 * @Description: 快手渠道待审模块
 */
'use strict';

angular.module('editKuaishouPendingModule', []).controller('EditKuaishouPendingCtrl', [
    '$scope',
    '$state',
    '$controller',
    'editingMediatype',
    'KuaishouConst',
    'editingCenterKuaishouservice',
    function (
        $scope,
        $state,
        $controller,
        editingMediatype,
        KuaishouConst,
        editingCenterKuaishouservice
    ) {
        initStatus();

        /**
         * [initStatus description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.trenchStatus = {
                // eslint-disable-next-line camelcase
                status_model: 1, // // 后台用来区分待编、待审、已签发
            };
            $scope.trenchData = {
                trenchConst: KuaishouConst, // 渠道需要的常量
            };
            $scope.trenchParams = {
                serviceid: 'mlf_kuaishou',
                methodName: 'queryToAudit',
            };
            $scope.trenchRightsParams = {
                methodname: 'queryOperKeyOfKuaishou',
                Classify: 'kuaishou.daishen',
                accountId: $state.params.account,
            };
            $scope.distributionMethodName = 'kuaiShouDaiShenDistribute'; // 多元分发接口名
            $controller('EditShortVideoListCtrl', { $scope: $scope }); // 控制器继承
        }

        /**
         * [kuaishouEditor description] 进入编辑页
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.kuaishouEditor = function(item){
            editingCenterKuaishouservice.routerToDraftPage($state.params.account, item.KUAISHOUARTICLEID, $scope.trenchStatus.status_model);
        };
    },
]);
